// LooksLikesPage.js

import React, { useContext, useEffect, useState } from 'react';
import { FaHeart } from 'react-icons/fa';
import { useAuth } from '../contexts/AuthContext';
import { LooksPostsContext } from '../contexts/LooksPostsContext';
import { useLooksLikes } from '../contexts/LooksLikesContext';
import LooksPost from './LooksPost';
import './MyPostsPage.css';           // reuse the same styling

const LooksLikesPage = () => {
  const { user } = useAuth();         // just for redirect / future use
  const { posts } = useContext(LooksPostsContext);
  const { userLikes } = useLooksLikes();

  /* cosmetic top-margin logic (copied from ClipsLikesPage) */
  const [topMargin, setTopMargin] = useState('120px');
  useEffect(() => {
    const updateMargin = () => {
      if (window.innerWidth === 1264) setTopMargin('140px');
      else if (window.innerWidth <= 768) setTopMargin('200px');
      else setTopMargin('120px');
    };
    window.addEventListener('resize', updateMargin);
    updateMargin();
    return () => window.removeEventListener('resize', updateMargin);
  }, []);

  /* filter posts the current user liked */
  const likedPosts = posts.filter(p => userLikes.includes(p.id));

  return (
    <div className="my-posts-container" style={{ marginTop: topMargin }}>
      <h1 style={{ textAlign: 'center' }}>
        <FaHeart /> Likes
      </h1>

      {likedPosts.length ? (
        likedPosts.map(p => (
          <div key={p.id} className="post-container">
            <LooksPost {...p} />      {/* spread keeps the prop list short */}
          </div>
        ))
      ) : (
        <p>You haven't liked any posts yet.</p>
      )}
    </div>
  );
};

export default LooksLikesPage;
